<ng-container *transloco="let t">
  <div class="main-content">
    @if (mapLocationPickerActive) {
      <div class="location-picker-overlay">
        <p-floatlabel variant="in">
          <p-autocomplete
            #searchAddressInput="ngModel"
            inputId="search-address-input"
            [(ngModel)]="autocompleteSearchAddressQuery"
            autocomplete="off"
            [style]="{ width: '100%' }"
            [disabled]="addressAutocompleteLoading"
            [suggestions]="addressAutocompleteResults"
            (completeMethod)="addressAutocomplete($event)"
            optionLabel="label"
            [forceSelection]="true"
            (onSelect)="onAddressAutocompleteSelect($event)"
            [delay]="500"
            minLength="4"
          />
          <label for="search-address-input">{{
            t("searchAddressOrSelectOnMap")
          }}</label>
        </p-floatlabel>
        <div class="buttons-row">
          <span class="cur-coordinates">{{
            currentLocationPickerSelection
          }}</span>
          <p-button
            icon="pi pi-times"
            [label]="t('cancel')"
            severity="secondary"
            (click)="closeLocationPicker()"
          />
          <p-button
            icon="pi pi-check"
            [label]="t('set')"
            severity="success"
            (click)="closeLocationPicker(mapLocationPickerSelection)"
          />
        </div>
      </div>
    } @else {
      <div
        class="data-section"
        id="data-section"
        [class.collapsed]="!dataSectionOpen"
        (click)="dataSectionOpen ? null : toggleDataSection($event)"
      >
        <div class="title-row">
          <h3>{{ t("bikesAndStationsManagement") }}</h3>
          <div
            class="toggle-button"
            pRipple
            (click)="toggleDataSection($event)"
            [class.reverse]="!dataSectionOpen"
          >
            <span class="material-symbols-outlined">chevron_left</span>
          </div>
          <div class="tab-headers-container">
            <div
              class="tab-header"
              pRipple
              (click)="setActiveTab('bikes')"
              [class.active]="activeTab === 'bikes'"
            >
              <span class="material-symbols-outlined icon">pedal_bike</span>
              <span class="label">{{ t("bikes") }}</span>
            </div>
            <div
              class="tab-header"
              pRipple
              (click)="setActiveTab('stations')"
              [class.active]="activeTab === 'stations'"
            >
              <span class="material-symbols-outlined icon">bike_dock</span>
              <span class="label">{{ t("stations") }}</span>
            </div>
          </div>
        </div>
        <div class="tab-panels-container">
          <!--? BIKES  -->
          <div class="tab-panel" [class.visible]="activeTab === 'bikes'">
            <div class="actions-row">
              <p-button
                [icon]="
                  'pi pi-refresh' +
                  (((bikesLoading$ | async) ?? true) ? ' pi-spin' : '')
                "
                [disabled]="(bikesLoading$ | async) ?? true"
                (click)="refreshBikes()"
              />

              <p-button
                icon="pi pi-filter"
                severity="info"
                [outlined]="!bikeFiltersDialogVisible"
                [disabled]="(bikesLoading$ | async) ?? true"
                (click)="toggleBikeFilters()"
                [label]="appliedBikeFiltersCount"
              />

              <input
                #bikesSearch
                type="text"
                pInputText
                id="bikes-search-input"
                (input)="bikesTable.filterGlobal(bikesSearch.value, 'contains')"
                [placeholder]="t('searchBikes')"
                class="search-input"
              />

              @if (canCreateBike) {
                <p-button
                  [label]="t('newFeminine')"
                  icon="pi pi-plus"
                  class="add-bike-button"
                  (click)="openBikeDialog()"
                />
              }

              @if (canDeleteBike) {
                <p-button
                  icon="pi pi-list-check"
                  severity="secondary"
                  [disabled]="selectedBikes.length === 0"
                  (click)="bikesBatchMenu.toggle($event)"
                />

                <p-menu
                  #bikesBatchMenu
                  [model]="bikeBatchMenu"
                  [popup]="true"
                  appendTo="body"
                />
              }
            </div>

            <p-skeleton
              class="skeleton-loader"
              height="100%"
              width="100%"
              [class.visible]="(bikesLoadingUI$ | async) ?? true"
            />

            <p-table
              #bikesTable
              class="bikes-table"
              id="bikes-table"
              [value]="bikes"
              [(selection)]="selectedBikes"
              [rowHover]="true"
              [paginator]="true"
              [rows]="10"
              [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
              sortMode="single"
              selectionMode="multiple"
              [rowTrackBy]="_bikesTrackBy"
              [metaKeySelection]="true"
              [resizableColumns]="true"
              columnResizeMode="fit"
              (selectionChange)="onBikeSelectionChange($event)"
              [globalFilterFields]="bikesFilterFields"
              stripedRows
              [scrollable]="true"
              [class.visible]="!((bikesLoadingUI$ | async) ?? true)"
            >
              <ng-template #header>
                <tr>
                  <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

                  @for (col of bikesColumns; track col.field) {
                    @if (col.visible ?? true) {
                      <th [pSortableColumn]="col.field" pResizableColumn>
                        <div class="table-header-row">
                          <span class="header-label">{{ t(col.header) }}</span>
                          <div class="header-buttons">
                            <p-sortIcon [field]="col.field" />
                          </div>
                        </div>
                      </th>
                    }
                  }
                </tr>
              </ng-template>
              <ng-template #body let-bike let-rowIndex="rowIndex">
                <tr
                  [pSelectableRow]="bike"
                  [pSelectableRowIndex]="rowIndex"
                  (contextmenu)="$event.preventDefault(); openBikeDialog(bike)"
                  (longPress)="openBikeDialog(bike)"
                  appLongPress
                >
                  <td (click)="$event.stopPropagation()">
                    <p-tableCheckbox [value]="bike" />
                  </td>
                  @for (col of bikesColumns; track col.field) {
                    @if (col.visible ?? true) {
                      <td>
                        <!-- CELLA -->
                        @if (col.wrapper) {
                          <ng-container
                            *ngComponentOutlet="
                              col.wrapper;
                              inputs: parseWrapperInputs(col, [
                                bike,
                                getCellData(col, bike),
                              ])
                            "
                          ></ng-container>
                        } @else {
                          <span [innerHTML]="getCellData(col, bike)"></span>
                        }
                      </td>
                    }
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>

          <!--? STATIONS  -->
          <div class="tab-panel" [class.visible]="activeTab === 'stations'">
            <div class="actions-row">
              <p-button
                [icon]="
                  'pi pi-refresh' +
                  ((stationsLoading$ | async) ? ' pi-spin' : '')
                "
                [disabled]="(stationsLoading$ | async) ?? true"
                (click)="refreshStations()"
              />

              <p-button
                icon="pi pi-filter"
                severity="info"
                [outlined]="!stationFiltersDialogVisible"
                [disabled]="(stationsLoading$ | async) ?? true"
                (click)="toggleStationFilters()"
                [label]="appliedStationFiltersCount"
              />

              <input
                #stationsSearch
                type="text"
                pInputText
                id="stations-search-input"
                (input)="
                  stationsTable.filterGlobal(stationsSearch.value, 'contains')
                "
                [placeholder]="t('searchStations')"
                class="search-input"
              />

              @if (canCreateStation) {
                <p-button
                  [label]="t('newFeminine')"
                  icon="pi pi-plus"
                  class="add-station-button"
                  (click)="openStationDialog()"
                />
              }

              @if (canDeleteStation) {
                <p-button
                  icon="pi pi-list-check"
                  severity="secondary"
                  [disabled]="selectedStations.length === 0"
                  (click)="stationsBatchMenu.toggle($event)"
                />
                <p-menu
                  #stationsBatchMenu
                  [model]="stationBatchMenu"
                  [popup]="true"
                  appendTo="body"
                />
              }
            </div>
            <p-skeleton
              class="skeleton-loader"
              height="100%"
              width="100%"
              [class.visible]="(stationsLoadingUI$ | async) ?? true"
            />

            <p-table
              #stationsTable
              class="stations-table"
              id="stations-table"
              [value]="stations"
              [(selection)]="selectedStations"
              [rowHover]="true"
              [paginator]="true"
              [rows]="10"
              [rowsPerPageOptions]="[5, 10, 15, 20, 50]"
              sortMode="single"
              selectionMode="multiple"
              [rowTrackBy]="_stationsTrackBy"
              [metaKeySelection]="true"
              [resizableColumns]="true"
              columnResizeMode="fit"
              [globalFilterFields]="stationsFilterFields"
              (selectionChange)="onStationSelectionChange($event)"
              stripedRows
              [scrollable]="true"
              [class.visible]="!((stationsLoadingUI$ | async) ?? true)"
            >
              <ng-template #header>
                <tr>
                  <th style="width: 3rem"><p-tableHeaderCheckbox /></th>

                  @for (col of stationColumns; track col.field) {
                    @if (col.visible ?? true) {
                      <th [pSortableColumn]="col.field" pResizableColumn>
                        <div class="table-header-row">
                          <span class="header-label">{{ t(col.header) }}</span>
                          <div class="header-buttons">
                            <p-sortIcon [field]="col.field" />
                          </div>
                        </div>
                      </th>
                    }
                  }
                </tr>
              </ng-template>
              <ng-template #body let-station let-rowIndex="rowIndex">
                <tr
                  [pSelectableRow]="station"
                  [pSelectableRowIndex]="rowIndex"
                  (contextmenu)="
                    $event.preventDefault(); openStationDialog(station)
                  "
                  (longPress)="openStationDialog(station)"
                  appLongPress
                >
                  <td (click)="$event.stopPropagation()">
                    <p-tableCheckbox [value]="station" />
                  </td>
                  @for (col of stationColumns; track col.field) {
                    @if (col.visible ?? true) {
                      <td>
                        <!-- CELLA -->
                        @if (col.wrapper) {
                          <ng-container
                            *ngComponentOutlet="
                              col.wrapper;
                              inputs: parseWrapperInputs(col, [
                                station,
                                getCellData(col, station),
                              ])
                            "
                          ></ng-container>
                        } @else {
                          <span [innerHTML]="getCellData(col, station)"></span>
                        }
                      </td>
                    }
                  }
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <h3 class="collapsed-title">{{ t("bikesAndStationsManagement") }}</h3>
      </div>
    }

    <div
      class="map-container"
      leaflet
      [leafletOptions]="mapOptions"
      [leafletLayers]="mapLayers"
      (leafletMapReady)="onMapReady($event)"
      (leafletClick)="onMapClick($event)"
    >
      <!-- <div [leafletLayer]="currentPosition"></div> -->
    </div>
  </div>

  <!--? STATION DIALOG  --------------------------------->
  <p-dialog
    [header]="
      isNewStationDialog
        ? t('newStation')
        : t('editStationWithCode', { code: stationDialogData.code })
    "
    [modal]="true"
    [(visible)]="stationDialogVisible"
    [style]="{ width: 'min(40rem, 90vw)', height: 'min(90vh, 730px)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="station-dialog"
    (onHide)="
      onHideStationDialog(stationForm); activeStationEditSection = 'data'
    "
  >
    @if (!isNewStationDialog) {
      <div class="buttons-row">
        <p-button
          [label]="t('data')"
          icon="pi pi-pencil"
          [severity]="
            activeStationEditSection == 'data' ? 'primary' : 'secondary'
          "
          [rounded]="true"
          size="small"
          (click)="activeStationEditSection = 'data'"
        />

        <p-button
          [label]="t('details')"
          icon="pi pi-info-circle"
          [severity]="
            activeStationEditSection == 'details' ? 'primary' : 'secondary'
          "
          [rounded]="true"
          size="small"
          (click)="activeStationEditSection = 'details'"
        />

        <p-button
          [label]="t('times')"
          icon="pi pi-clock"
          [severity]="
            activeStationEditSection == 'times' ? 'primary' : 'secondary'
          "
          [rounded]="true"
          size="small"
          (click)="activeStationEditSection = 'times'"
        />
      </div>
    }

    <form
      class="station-form"
      #stationForm="ngForm"
      [class.visible]="activeStationEditSection == 'data'"
    >
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #stationCodeInput="ngModel"
          pInputText
          id="station-code-input"
          name="code"
          [(ngModel)]="stationDialogData.code"
          autocomplete="off"
          required
          [disabled]="((stationsLoading$ | async) ?? true) || !canEditStation"
        />
        <label for="station-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? DESCRIPTION ----------------------------->
      <p-floatlabel variant="in">
        <input
          #stationDescriptionInput="ngModel"
          pInputText
          id="station-description-input"
          name="description"
          [(ngModel)]="stationDialogData.description"
          autocomplete="off"
          required
          [disabled]="((stationsLoading$ | async) ?? true) || !canEditStation"
        />
        <label for="station-description-input">
          {{ t("description") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? COORDINATES ----------------------------->
      <div class="form-row stretch">
        <p-floatlabel variant="in">
          <p-inputnumber
            #stationLatInput="ngModel"
            inputId="station-lat-input"
            name="lat"
            [(ngModel)]="stationDialogData.lat"
            autocomplete="off"
            [minFractionDigits]="6"
            [maxFractionDigits]="6"
            [min]="-90"
            [max]="90"
            required
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-lat-input">
            {{ t("latitude") }}
            <span class="mandatory-label">*</span>
          </label>
        </p-floatlabel>

        <p-floatlabel variant="in">
          <p-inputnumber
            #stationLngInput="ngModel"
            inputId="station-lng-input"
            name="lng"
            [(ngModel)]="stationDialogData.lng"
            autocomplete="off"
            [minFractionDigits]="6"
            [maxFractionDigits]="6"
            [min]="-180"
            [max]="180"
            required
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-lng-input">
            {{ t("longitude") }}
            <span class="mandatory-label">*</span>
          </label>
        </p-floatlabel>

        <p-button
          icon="pi pi-map-marker"
          [style]="{ height: '100%' }"
          severity="help"
          (click)="openLocationPicker('station')"
          [disabled]="
            ((stationsLoading$ | async) ?? true) ||
            synchingCoordinates ||
            !canEditStation
          "
        />

        <p-button
          icon="pi pi-search"
          [style]="{ height: '100%' }"
          severity="secondary"
          (click)="syncCoordinatesAndAddress()"
          [disabled]="
            ((stationsLoading$ | async) ?? true) ||
            synchingCoordinates ||
            !canEditStation
          "
          [outlined]="true"
        />
      </div>

      <!--? ADDRESS --------------------------------->
      <div class="form-row stretch">
        <p-floatlabel variant="in">
          <input
            #stationAddressInput="ngModel"
            pInputText
            id="station-address-input"
            name="address"
            [(ngModel)]="stationDialogData.address"
            autocomplete="off"
            [style]="{ 'min-width': '23rem' }"
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-address-input">{{ t("address") }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
          <input
            #stationProvinceInput="ngModel"
            pInputText
            id="station-province-input"
            name="province"
            [(ngModel)]="stationDialogData.province"
            autocomplete="off"
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-province-input">{{ t("province") }}</label>
        </p-floatlabel>
      </div>

      <div class="form-row stretch">
        <p-floatlabel variant="in">
          <input
            #stationCityInput="ngModel"
            pInputText
            id="station-city-input"
            name="city"
            [(ngModel)]="stationDialogData.city"
            autocomplete="off"
            [style]="{ 'min-width': '16rem' }"
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-city-input">{{ t("city") }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
          <input
            #stationZipInput="ngModel"
            pInputText
            id="station-zip-input"
            name="zip"
            [(ngModel)]="stationDialogData.zip"
            autocomplete="off"
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-zip-input">{{ t("zip") }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
          <input
            #stationCountryInput="ngModel"
            pInputText
            id="station-countryCode-input"
            name="countryCode"
            [(ngModel)]="stationDialogData.countryCode"
            autocomplete="off"
            [disabled]="
              ((stationsLoading$ | async) ?? true) ||
              synchingCoordinates ||
              !canEditStation
            "
          />
          <label for="station-countryCode-input">{{ t("country") }}</label>
        </p-floatlabel>
      </div>

      <!--? PICTURES ------------------------->
      @if (canEditStation) {
        <div class="pictures-row">
          <label
            for="station-main-picture-input"
            class="picture-input-label"
            [class.filled]="
              fileState.logoPicturePreview || fileState.logoPictureFile
            "
            [pTooltip]="t('logoPicture')"
            [showDelay]="300"
            tooltipPosition="top"
          >
            @if (fileState.logoPicturePreview) {
              <img
                [src]="fileState.logoPicturePreview"
                [alt]="t('logoPicture')"
              />
            } @else {
              <span class="material-symbols-outlined placeholder-icon">
                image
              </span>
            }

            @if (fileState.logoPicturePreview || fileState.logoPictureFile) {
              <span
                class="material-symbols-outlined delete-icon"
                (click)="$event.preventDefault(); clearImage('logoPicture')"
              >
                delete
              </span>
            }

            @if (fileState.logoPictureFile) {
              <div
                class="to-upload-badge"
                [pTooltip]="t('toUpload')"
                [showDelay]="300"
              >
                <span class="material-symbols-outlined icon"> upload </span>
              </div>
            }
          </label>
          <input
            type="file"
            id="station-main-picture-input"
            accept="image/*"
            class="hidden-input"
            name="logoPicture"
            (change)="onFileSelected($event, 'logoPicture')"
          />

          <label
            for="station-2-picture-input"
            class="picture-input-label"
            [class.filled]="
              fileState.stationPicturePreview || fileState.stationPictureFile
            "
            [pTooltip]="t('stationPicture')"
            [showDelay]="300"
            tooltipPosition="top"
          >
            @if (fileState.stationPicturePreview) {
              <img
                [src]="fileState.stationPicturePreview"
                [alt]="t('stationPicture')"
              />
            } @else {
              <span class="material-symbols-outlined placeholder-icon">
                pedal_bike
              </span>
            }

            @if (
              fileState.stationPicturePreview || fileState.stationPictureFile
            ) {
              <span
                class="material-symbols-outlined delete-icon"
                (click)="$event.preventDefault(); clearImage('stationPicture')"
              >
                delete
              </span>
            }

            @if (fileState.stationPictureFile) {
              <div
                class="to-upload-badge"
                [pTooltip]="t('toUpload')"
                [showDelay]="300"
              >
                <span class="material-symbols-outlined icon"> upload </span>
              </div>
            }
          </label>
          <input
            type="file"
            id="station-2-picture-input"
            accept="image/*"
            class="hidden-input"
            name="stationPicture"
            (change)="onFileSelected($event, 'stationPicture')"
          />

          <label
            for="station-3-picture-input"
            class="picture-input-label"
            [class.filled]="
              fileState.outsidePicturePreview || fileState.outsidePictureFile
            "
            [pTooltip]="t('outsidePicture')"
            [showDelay]="300"
            tooltipPosition="top"
          >
            @if (fileState.outsidePicturePreview) {
              <img
                [src]="fileState.outsidePicturePreview"
                [alt]="t('outsidePicture')"
              />
            } @else {
              <span class="material-symbols-outlined placeholder-icon">
                streetview
              </span>
            }

            @if (
              fileState.outsidePicturePreview || fileState.outsidePictureFile
            ) {
              <span
                class="material-symbols-outlined delete-icon"
                (click)="$event.preventDefault(); clearImage('outsidePicture')"
              >
                delete
              </span>
            }

            @if (fileState.outsidePictureFile) {
              <div
                class="to-upload-badge"
                [pTooltip]="t('toUpload')"
                [showDelay]="300"
              >
                <span class="material-symbols-outlined icon"> upload </span>
              </div>
            }
          </label>
          <input
            type="file"
            id="station-3-picture-input"
            accept="image/*"
            class="hidden-input"
            name="outsidePicture"
            (change)="onFileSelected($event, 'outsidePicture')"
          />
        </div>
        <p class="pictures-suggestion-label">
          {{ t("stationPicturesSuggestion") }}
        </p>
      }
    </form>

    <form
      class="station-form"
      #stationDetailsForm="ngForm"
      [class.visible]="activeStationEditSection == 'details'"
    >
      <!--? MAX BIKES ----------------------------->
      <p-floatlabel variant="in">
        <p-inputnumber
          #stationMaxBikesInput="ngModel"
          id="station-max-bikes-input"
          name="maxBikes"
          [(ngModel)]="stationDialogData.maxBikes"
          autocomplete="off"
          [disabled]="((stationsLoading$ | async) ?? true) || !canEditStation"
          min="0"
        />
        <label for="station-max-bikes-input">
          {{ t("maxBikes") }}
        </label>
      </p-floatlabel>
    </form>

    <div
      class="station-times"
      [class.visible]="activeStationEditSection == 'times'"
    >
      @for (dayIndex of getDayIndices(); track dayIndex) {
        @let day = stationOpeningTimes[dayIndex];

        @if (day) {
          <div class="day-row" [class.copying]="dayIndex === copyingTimesIndex">
            <span class="day-name">{{ t("primeng.dayNames")[dayIndex] }}</span>
            <p-toggleswitch
              [(ngModel)]="day.enabled"
              (onChange)="stationTimesSwitchChange($event, dayIndex)"
              class="day-switch"
              *ngIf="!isCopying"
              [disabled]="!canEditStation"
            />

            @if (day.enabled) {
              <p-button
                icon="pi pi-plus"
                class="add-time-button"
                [rounded]="true"
                size="small"
                severity="info"
                (click)="addTime(dayIndex)"
                *ngIf="!isCopying"
                [disabled]="!canEditStation"
              />

              @if (dayIndex !== copyingTimesIndex) {
                @if (!isCopying) {
                  <p-button
                    icon="pi pi-copy"
                    class="copy-day-button"
                    [rounded]="true"
                    size="small"
                    severity="help"
                    (click)="copyTimes(dayIndex)"
                    [disabled]="!canEditStation"
                  />
                }
              } @else {
                <p-button
                  icon="pi pi-check"
                  class="cancel-copy-day-button small-button"
                  [rounded]="true"
                  size="small"
                  severity="help"
                  (click)="cancelCopyTimes()"
                  [disabled]="!canEditStation"
                />
              }
            }

            @if (isCopying && copyingTimesIndex !== dayIndex) {
              <p-button
                icon="pi pi-clipboard"
                class="paste-day-button"
                [rounded]="true"
                size="small"
                severity="help"
                (click)="pasteTimes(dayIndex)"
                [disabled]="!canEditStation"
              />
            }

            <div class="day-times">
              @if ((day.times ?? []).length > 0 && day.enabled) {
                @for (
                  time of day.times;
                  track timeIndex;
                  let timeIndex = $index
                ) {
                  <div class="time-row">
                    <p-inputMask
                      #start
                      mask="99:99"
                      [(ngModel)]="time.open"
                      placeholder="--:--"
                      slotChar="--:--"
                      class="time-input"
                      pattern="^([0-1][0-9]|2[0-3]):[0-5][0-9]$"
                      maxlength="5"
                      (onComplete)="end.focus()"
                      [inputId]="
                        'time-open-' + timeIndex + '-input-day-' + dayIndex
                      "
                      [disabled]="isCopying || !canEditStation"
                      (onBlur)="formatTime(time, 'open', dayIndex, timeIndex)"
                      required
                    />

                    <span class="range-separator">-</span>

                    <p-inputMask
                      #end
                      mask="99:99"
                      [(ngModel)]="time.close"
                      placeholder="--:--"
                      slotChar="--:--"
                      class="time-input"
                      pattern="^([0-1][0-9]|2[0-3]):[0-5][0-9]$"
                      maxlength="5"
                      [inputId]="
                        'time-close-' + timeIndex + '-input-day-' + dayIndex
                      "
                      [disabled]="isCopying || !canEditStation"
                      (onBlur)="formatTime(time, 'close', dayIndex, timeIndex)"
                      required
                    />

                    <p-button
                      icon="pi pi-trash"
                      class="delete-time-button"
                      [rounded]="true"
                      [outlined]="true"
                      size="small"
                      severity="danger"
                      (click)="deleteTime(dayIndex, timeIndex)"
                      [disabled]="isCopying || !canEditStation"
                    />
                  </div>
                }
              } @else {
                <span class="closed-label">{{ t("closed") }}</span>
              }
            </div>
          </div>
        }
      }
    </div>

    <ng-template #footer>
      @if (!isNewStationDialog && canDeleteStation) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteStation()"
          class="delete-button"
          [outlined]="true"
          [disabled]="
            ((stationsLoading$ | async) ?? true) || synchingCoordinates
          "
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideStationDialog(stationForm)"
        [outlined]="true"
      />

      @if (canEditStation) {
        <p-button
          [label]="t('save')"
          severity="primary"
          (click)="saveStation()"
          [disabled]="
            ((stationsLoading$ | async) ?? true) ||
            !stationForm.valid ||
            !stationDetailsForm.valid ||
            synchingCoordinates
          "
        />
      }
    </ng-template>
  </p-dialog>

  <!--? STATION FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t('filterStations')"
    [(visible)]="stationFiltersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="station-filter-dialog"
    (onHide)="onStationFiltersDialogHide()"
  >
    <form class="station-filter-form" #stationFilterForm="ngForm">
      <!--? CITY ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #stationFilterCityInput="ngModel"
          inputId="station-filter-city"
          name="station-filter-city"
          appendTo="body"
          [options]="stationFilters.options.city"
          [(ngModel)]="stationFilters.values.city"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
        />
        <label for="station-filter-city">
          {{ t("city") }}
        </label>
      </p-floatlabel>

      <!-- <div class="form-row stretch"> -->
      <!--? ZIP ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #stationFilterZipInput="ngModel"
          inputId="station-filter-zip"
          name="station-filter-zip"
          appendTo="body"
          [options]="stationFilters.options.zip"
          [(ngModel)]="stationFilters.values.zip"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
        />
        <label for="station-filter-zip">
          {{ t("zip") }}
        </label>
      </p-floatlabel>

      <!--? PROVINCE ------------------------>
      <p-floatlabel variant="in">
        <p-multiselect
          #stationFilterProvinceInput="ngModel"
          inputId="station-filter-province"
          name="station-filter-province"
          appendTo="body"
          [options]="stationFilters.options.province"
          [(ngModel)]="stationFilters.values.province"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
        />
        <label for="station-filter-province">
          {{ t("province") }}
        </label>
      </p-floatlabel>

      <!--? COUNTRY ------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #stationFilterCountryInput="ngModel"
          inputId="station-filter-countryCode"
          name="station-filter-countryCode"
          appendTo="body"
          [options]="stationFilters.options.countryCode"
          [(ngModel)]="stationFilters.values.countryCode"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
        />
        <label for="station-filter-countryCode">
          {{ t("country") }}
        </label>
      </p-floatlabel>
      <!-- </div> -->
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="stationFilters.values = {}; refreshStations()"
        [disabled]="(stationsLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshStations()"
        [disabled]="(stationsLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>

  <!--? BIKE DIALOG  --------------------------------->
  <p-dialog
    [header]="
      isNewBikeDialog
        ? t('newBike')
        : t('editBikeWithCode', { code: bikeDialogData.code })
    "
    [modal]="true"
    [(visible)]="bikeDialogVisible"
    [style]="{ width: 'min(32rem, 90vw)', height: 'min(90vh, 730px)' }"
    [maximizable]="false"
    [draggable]="false"
    appendTo="body"
    [focusOnShow]="true"
    [dismissableMask]="false"
    [maskStyle]="{ 'backdrop-filter': 'blur(10px)' }"
    styleClass="bike-dialog"
    (onHide)="
      bikeForm.reset(bikeDialogData);
      iotForm.reset(bikeDialogData);
      activeBikeEditSection = 'data';
      bikeDetailsSub?.unsubscribe()
    "
  >
    <div class="buttons-row">
      <p-button
        [label]="t('data')"
        icon="pi pi-pencil"
        [severity]="activeBikeEditSection == 'data' ? 'primary' : 'secondary'"
        [rounded]="true"
        size="small"
        (click)="activeBikeEditSection = 'data'"
      />

      <p-button
        [label]="t('iot')"
        icon="pi pi-cloud"
        [severity]="activeBikeEditSection == 'iot' ? 'primary' : 'secondary'"
        [rounded]="true"
        size="small"
        (click)="activeBikeEditSection = 'iot'"
      />
    </div>

    <form
      class="bike-form"
      #bikeForm="ngForm"
      [class.visible]="activeBikeEditSection == 'data'"
    >
      <!--? CODE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #bikeCodeInput="ngModel"
          pInputText
          id="bike-code-input"
          name="code"
          [(ngModel)]="bikeDialogData.code"
          autocomplete="off"
          required
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
        />
        <label for="bike-code-input">
          {{ t("code") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? PROGRESSIVE ----------------------------->
      <p-floatlabel variant="in">
        <input
          #bikeProgressiveInput="ngModel"
          pInputText
          id="bike-progressive-input"
          name="progressive"
          [(ngModel)]="bikeDialogData.progressive"
          autocomplete="off"
          required
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
        />
        <label for="bike-progressive-input">
          {{ t("progressive") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? DESCRIPTION ----------------------------->
      <p-floatlabel variant="in">
        <input
          #bikeDescriptionInput="ngModel"
          pInputText
          id="bike-description-input"
          name="description"
          [(ngModel)]="bikeDialogData.description"
          autocomplete="off"
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
        />
        <label for="bike-description-input">
          {{ t("description") }}
        </label>
      </p-floatlabel>

      <!--? COORDINATES ----------------------------->
      <!-- <div class="form-row stretch">
        <p-floatlabel variant="in">
          <p-inputnumber
            #bikeLatInput="ngModel"
            inputId="bike-lat-input"
            name="lat"
            [(ngModel)]="bikeDialogData.lat"
            autocomplete="off"
            [minFractionDigits]="6"
            [maxFractionDigits]="6"
            [min]="-90"
            [max]="90"
            [disabled]="(bikesLoading$ | async) ?? true"
          />
          <label for="bike-lat-input">
            {{ t("latitude") }}
          </label>
        </p-floatlabel>

        <p-floatlabel variant="in">
          <p-inputnumber
            #bikeLngInput="ngModel"
            inputId="bike-lng-input"
            name="lng"
            [(ngModel)]="bikeDialogData.lng"
            autocomplete="off"
            [minFractionDigits]="6"
            [maxFractionDigits]="6"
            [min]="-180"
            [max]="180"
            [disabled]="(bikesLoading$ | async) ?? true"
          />
          <label for="bike-lng-input">
            {{ t("longitude") }}
          </label>
        </p-floatlabel>

        <p-button
          icon="pi pi-map-marker"
          [style]="{ height: '100%' }"
          severity="help"
          (click)="openLocationPicker('bike')"
          [disabled]="(bikesLoading$ | async) ?? true"
        />
      </div> -->

      <!--? BASE STATION ---------------------------->
      <p-floatlabel variant="in">
        <p-select
          #bikeCurrentStationInput="ngModel"
          inputId="bike-currentStation-input"
          name="currentStation"
          [(ngModel)]="bikeDialogData.currentStation"
          autocomplete="off"
          [disabled]="
            ((stationsLoading$ | async) ?? true) ||
            ((bikesLoading$ | async) ?? true) ||
            !canEditBike
          "
          [options]="stations"
          optionLabel="code"
          optionValue="stationId"
          appendTo="body"
          styleClass="w-full"
          [showClear]="true"
        />
        <label for="bike-currentStation-input">
          {{ t("currentStation") }}
        </label>
      </p-floatlabel>

      <!--? MODEL ---------------------------->
      <p-floatlabel variant="in">
        <p-select
          #bikeModelInput="ngModel"
          inputId="bike-station-input"
          name="model"
          [(ngModel)]="bikeDialogData.model"
          autocomplete="off"
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
          [options]="bikesModels"
          optionLabel="code"
          optionValue="modelId"
          appendTo="body"
          styleClass="w-full"
          required
        />
        <label for="bike-station-input">
          {{ t("model") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>

      <!--? STATUS ---------------------------------->
      <p-floatlabel variant="in">
        <p-select
          #bikeStatusInput="ngModel"
          inputId="bike-status-input"
          name="status"
          [(ngModel)]="bikeDialogData.status"
          autocomplete="off"
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
          [options]="bikesStatuses"
          optionLabel="description"
          optionValue="code"
          appendTo="body"
          styleClass="w-full"
          required
        />
        <label for="bike-status-input">
          {{ t("status") }}
          <span class="mandatory-label">*</span>
        </label>
      </p-floatlabel>
    </form>

    <form
      class="iot-form"
      #iotForm="ngForm"
      [class.visible]="activeBikeEditSection == 'iot'"
    >
      <!--? IMEI ----------------------------->
      <p-floatlabel variant="in">
        <p-autocomplete
          #imeiInput="ngModel"
          inputId="bike-imei-input"
          name="imei"
          [(ngModel)]="bikeDialogData.imei"
          [style]="{ width: '100%' }"
          [suggestions]="iotConnectedImeisAutocomplete"
          (completeMethod)="autocompleteImeis($event)"
          [forceSelection]="false"
          [delay]="200"
          minLength="1"
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
        />

        <label for="bike-imei-input">
          {{ t("imei") }}
        </label>
      </p-floatlabel>

      <!--? IDENTIFIER ----------------------------->
      <p-floatlabel variant="in">
        <input
          #bikeIdentifierInput="ngModel"
          pInputText
          id="bike-identifier-input"
          name="identifier"
          [(ngModel)]="bikeDialogData.identifier"
          autocomplete="off"
          required
          [disabled]="((bikesLoading$ | async) ?? true) || !canEditBike"
        />
        <label for="bike-identifier-input">
          {{ t("identifier") }}
        </label>
      </p-floatlabel>

      @if (canEditBike) {
        <div class="iot-details-buttons">
          <p-button
            [label]="t('unlockBike')"
            severity="help"
            (click)="unlockBike(bikeDialogData)"
            icon="pi pi-lock-open"
            size="small"
          />

          <p-button
            [label]="t('rebootDevice')"
            severity="secondary"
            (click)="rebootDevice(bikeDialogData)"
            icon="pi pi-power-off"
            size="small"
          />
        </div>
      }

      @if (bikeDialogData.iotStatus && bikeDialogData.iotStatus != "ni") {
        <div class="iot-details-card card-lock">
          <div class="card-header">
            <span class="material-symbols-outlined header-icon"> lock </span>
            <span class="header-label">{{ t("lock") }}</span>
          </div>
          <div class="card-body">
            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                {{ bikeDialogData.iotStatus == "na" ? "hourglass_top" : "hub" }}
              </span>
              <p class="data-label">{{ t("iotStatus") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    t(
                      bikeDialogData.iotStatus == "na"
                        ? "notConnected"
                        : "connected"
                    )
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> bolt </span>
              <p class="data-label">{{ t("battery") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    (bikeDialogData.iotDetails?.lock?.battery?.voltage ??
                      "--") +
                      "v | " +
                      (bikeDialogData.iotDetails?.lock?.battery?.level ??
                        "--") +
                      "%"
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                {{
                  (bikeDialogData.iotDetails?.lock?.isLocked ?? false)
                    ? "lock"
                    : "lock_open"
                }}
              </span>
              <p class="data-label">{{ t("status") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    t(
                      (bikeDialogData.iotDetails?.lock?.isLocked ?? false)
                        ? "locked"
                        : "unlocked"
                    )
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> history </span>
              <p class="data-label">{{ t("lastStatusUpdate") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    bikeDialogData.iotDetails?.lock?.lockChangeTimestamp
                      ? (bikeDialogData.iotDetails?.lock?.lockChangeTimestamp ??
                          ""
                        | translocoDate
                          : { dateStyle: "short", timeStyle: "medium" })
                      : "--"
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                signal_cellular_3_bar
              </span>
              <p class="data-label">{{ t("signalPower") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.iot?.networkSignal ?? "--" }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                dangerous
              </span>
              <p class="data-label">{{ t("errorCode") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.iot?.errorCode ?? "--" }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> history </span>
              <p class="data-label">{{ t("lastUpdate") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    bikeDialogData.iotDetails?.iot?.lastUpdate
                      ? (bikeDialogData.iotDetails?.iot?.lastUpdate ?? ""
                        | translocoDate
                          : { dateStyle: "short", timeStyle: "medium" })
                      : "--"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="iot-details-card bike-lock">
          <div class="card-header">
            <span class="material-symbols-outlined header-icon">
              pedal_bike
            </span>
            <span class="header-label">{{ t("bike") }}</span>
          </div>
          <div class="card-body">
            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> bolt </span>
              <p class="data-label">{{ t("battery") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    (bikeDialogData.iotDetails?.bike?.battery?.status ?? "--") +
                      " | " +
                      (bikeDialogData.iotDetails?.bike?.battery?.level ??
                        "--") +
                      "%"
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                power_settings_new
              </span>
              <p class="data-label">{{ t("powerStatus") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    t(
                      (bikeDialogData.iotDetails?.bike?.isOn ?? false)
                        ? "onFeminine"
                        : "offFeminine"
                    )
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                {{
                  (bikeDialogData.iotDetails?.bike?.headlight ?? false)
                    ? "flashlight"
                    : "flashlight_off"
                }}
              </span>
              <p class="data-label">{{ t("headlight") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    t(
                      (bikeDialogData.iotDetails?.bike?.headlight ?? false)
                        ? "on"
                        : "off"
                    )
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                motion_blur
              </span>
              <p class="data-label">{{ t("currentSpeed") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    (bikeDialogData.iotDetails?.bike?.currentSpeed ?? "--") +
                      " km/h"
                  }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                dangerous
              </span>
              <p class="data-label">{{ t("faultCode") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.bike?.faultCode ?? "--" }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> history </span>
              <p class="data-label">{{ t("lastUpdate") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    bikeDialogData.iotDetails?.bike?.lastUpdate
                      ? (bikeDialogData.iotDetails?.bike?.lastUpdate ?? ""
                        | translocoDate
                          : { dateStyle: "short", timeStyle: "medium" })
                      : "--"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="iot-details-card location-lock">
          <div class="card-header">
            <span class="material-symbols-outlined header-icon">
              my_location
            </span>
            <span class="header-label">{{ t("location") }}</span>
          </div>
          <div class="card-body">
            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> height </span>
              <p class="data-label">{{ t("latitude") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.location?.lat ?? "--" }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> width </span>
              <p class="data-label">{{ t("longitude") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.location?.lng ?? "--" }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                altitude
              </span>
              <p class="data-label">{{ t("altitude") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ (bikeDialogData.iotDetails?.location?.alt ?? "--") + "m" }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> target </span>
              <p class="data-label">{{ t("accuracy") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.location?.accuracy }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon">
                satellite_alt
              </span>
              <p class="data-label">{{ t("numberOfSatellites") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{ bikeDialogData.iotDetails?.location?.numberOfSatellites }}
                </p>
              </div>
            </div>

            <div class="data-row">
              <span class="material-symbols-outlined data-icon"> history </span>
              <p class="data-label">{{ t("lastUpdate") }}</p>

              <div class="data-value-container">
                <p class="data-value">
                  {{
                    bikeDialogData.iotDetails?.location?.lastUpdate
                      ? (bikeDialogData.iotDetails?.location?.lastUpdate ?? ""
                        | translocoDate
                          : { dateStyle: "short", timeStyle: "medium" })
                      : "--"
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      }
    </form>

    <ng-template #footer>
      @if (!isNewBikeDialog && canDeleteBike) {
        <p-button
          [label]="t('delete')"
          severity="danger"
          (click)="deleteBike()"
          class="delete-button"
          [outlined]="true"
          [disabled]="(bikesLoading$ | async) ?? true"
        />
      }
      <p-button
        [label]="t('cancel')"
        severity="secondary"
        (click)="hideBikeDialog()"
        [outlined]="true"
      />
      @if (canEditBike) {
        <p-button
          [label]="t('save')"
          severity="primary"
          (click)="saveBike()"
          [disabled]="((bikesLoading$ | async) ?? true) || !bikeForm.valid"
        />
      }
    </ng-template>
  </p-dialog>

  <!--? BIKE FILTERS DIALOG --------------------------------->
  <p-dialog
    [header]="t('filterBikes')"
    [(visible)]="bikeFiltersDialogVisible"
    [style]="{
      width: 'min(30rem, 80vw)',
      'min-width': '430px',
      'max-width': '90vw',
      'max-height': '90vh',
      'min-height': '10rem',
    }"
    [maximizable]="false"
    [draggable]="true"
    appendTo="body"
    styleClass="bike-filter-dialog"
    (onHide)="onBikeFiltersDialogHide()"
  >
    <form class="bike-filter-form" #bikeFilterForm="ngForm">
      <!--? STATUS ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #bikeFilterStatusInput="ngModel"
          inputId="bike-filter-status"
          name="bike-filter-status"
          appendTo="body"
          [options]="
            translateObjectValues(bikeFilters.options.status, 'description')
          "
          [(ngModel)]="bikeFilters.values.status"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
          optionLabel="description"
          optionValue="code"
        />
        <label for="bike-filter-status">
          {{ t("status") }}
        </label>
      </p-floatlabel>

      <!--? BASE STATION ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #bikeFIlterCurrentStationInput="ngModel"
          inputId="bike-filter-currentStation"
          name="bike-filter-currentStation"
          appendTo="body"
          [options]="bikeFilters.options.currentStation"
          [(ngModel)]="bikeFilters.values.currentStation"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
          optionLabel="code"
          optionValue="stationId"
        />
        <label for="bike-filter-currentStation">
          {{ t("currentStation") }}
        </label>
      </p-floatlabel>

      <!--? MODEL ----------------------------->
      <p-floatlabel variant="in">
        <p-multiselect
          #bikeFilterModelInput="ngModel"
          inputId="bike-filter-model"
          name="bike-filter-model"
          appendTo="body"
          [options]="bikeFilters.options.model"
          [(ngModel)]="bikeFilters.values.model"
          filter
          styleClass="w-full"
          [maxSelectedLabels]="3"
          [showClear]="true"
          optionLabel="code"
          optionValue="modelId"
        />
        <label for="bike-filter-model">
          {{ t("model") }}
        </label>
      </p-floatlabel>
    </form>

    <ng-template #footer>
      <p-button
        [label]="t('clear')"
        severity="danger"
        [outlined]="true"
        (click)="bikeFilters.values = {}; refreshBikes()"
        [disabled]="(bikesLoading$ | async) ?? true"
      />
      <p-button
        [label]="t('apply')"
        severity="primary"
        (click)="refreshBikes()"
        [disabled]="(bikesLoading$ | async) ?? true"
      />
    </ng-template>
  </p-dialog>
</ng-container>
